import { Action } from "redux";

export const SET_CHANGES_GENERATED = "SET_CHANGES_GENERATED";

export interface SetChangesGeneratedDateAction extends Action {
    date: string;
}

export const setChangesGeneratedDateAction = (date: string): SetChangesGeneratedDateAction => {
    return {
        type: SET_CHANGES_GENERATED,
        date: date,
    };
};
